import { Component, inject } from "@angular/core";
import { DeviceService } from "../../../device/device.service";

@Component({
    selector: "devices-all",
    templateUrl: "./devices-all.html",
    styleUrls: ["./devices-all.css"],
    standalone: false
})
export class DevicesAllComponent {
  private readonly deviceService = inject(DeviceService);

  protected readonly devices$ = this.deviceService.all;

  protected readonly displayedColumns = ["assetName", "serialNumber", "physicalAddress", "createdOn", "lastActivityOn", "batteryLevel"];
}
